import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  SimpleGrid,
  Text,
  Flex,
  GridItem,
  Switch,
  useToast,
  Icon,
  Badge,
  CheckboxGroup,
  Checkbox,
} from '@chakra-ui/react'
import { Button } from '../../../../components/Button'
import { FaEdit } from 'react-icons/fa'
import { Input } from '../../../../components/Form/Input'
import { useForm, FormProvider } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { InputMaskForm } from '../../../../components/Form/InputMaskForm'
import { InputSearchCep } from './InputSearchCep'
import { Origem } from '../components/Origem'
import { ConsultaCPFCnpj } from '../components/ConsultaCPFCnpj'
import { ClassificacaoICMS } from '../components/ClassificacaoICMS'
import { ConsultarReceita } from '../components/ConsultarReceita'
import { api } from '../../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { useEffect } from 'react'
import { Emails } from '../AddCliente/Emails'
import { ListaContato } from '../components/ListaContato'
import { updateClientSchema } from '../@schemas/updateClient'
import { user } from '../../../../helpers/user'
import { TipoDePessoa } from '../components/TipoDePessoa'

async function onEditClient(data) {
  const responsee = await api.put('/orcamento-pedido/atualizar-cliente', data)

  return responsee.data
}

export function EditarCliente({ dataClient, isOpen, onClose }) {
  const methods = useForm({
    resolver: zodResolver(updateClientSchema),
  })

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    duration: 5000,
    isClosable: true,
  })

  const {
    control,
    handleSubmit,
    register,
    formState: { errors },
    setValue,
    watch,
  } = methods

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: onEditClient,
    onSuccess: () => {
      queryClient.invalidateQueries('clientes')

      toast({
        title: 'Cliente editado com sucesso',
        status: 'success',
      })

      onClose()
    },
    onError: () => {
      toast({
        title: 'Erro ao editar cliente',
        status: 'error',
      })
    },
  })

  async function handleEdit(data) {
    const params = {
      codigo_vendedor: user.codigo_vendedor,
      numero_contrato: data.contract,
      id_contato: dataClient.id_contato,
      id_parceiro: dataClient.id_parceiro,
      nome_contato: data.name,
      email_contato: data.email,
      inscricao_estadual: data.stateRegistration,
      razao_social: data.socialReason,
      nome_parceiro: data.partnerName,
      celular: data.cellphoneClient,
      telefone: data.phoneClient,
      cnpj: data.cnpjCpf,
      tipo_pessoa: data.personType.value,
      cliente_especial: data.specialClient,
      fax: data.phoneAddress,
      ramal: data.branch,
      cep: data.cep,
      codigo_origem_contato: data.origin.value,
      classificacao_icms: data.icmsClassification.value,
      email_notifica_nfe: data.emails.map((email) => email.email),
      rua: data.street,
      complemento: data.complement,
      tipo_logradouro: data.street,
      uf: data.state,
      cidade: data.city,
      bairro: data.neighborhood,
      numero_endereco: data.number,
      contatos: data.contatos.map((contato) => ({
        id_contato: contato.id_contato,
        nome_contato: contato.nome,
        telefone: contato.telefone,
        email_contato: contato.email,
        celular: contato.celular,
        cargo: contato.cargo,
        departamento: contato.departamento,
        apelido: contato.apelido,
        data_nascimento: contato.data_nascimento,
      })),
      editar_endereco: data.editar_endereco,
    }

    await mutateAsync(params)
  }

  useEffect(() => {
    if (dataClient) {
      const emails = JSON.parse(dataClient?.emails?.replace(',]', ']')) //não pode mudar isso

      const tipoPessoa = dataClient.tipo_pessoa === 'F' ? 'Pessoa Física' : 'Pessoa Jurídica'

      setValue('contract', dataClient?.num_contrato ? dataClient?.num_contrato : '')
      setValue('name', dataClient?.nome_contato_principal)
      setValue('email', dataClient?.email_contato_principal)
      setValue('cellphoneClient', dataClient?.celular_principal)
      setValue('phoneClient', dataClient?.telefone_principal)
      setValue('partnerName', dataClient?.nome_parceiro)
      setValue('cnpjCpf', dataClient.cnpj)
      setValue('personType', { value: tipoPessoa, label: tipoPessoa })
      setValue('specialClient', dataClient.cliente_especial === 'S' ? true : false)
      setValue('stateRegistration', dataClient.inscricao_estadual ?? '')
      setValue('socialReason', dataClient.razao_social)
      setValue('branch', dataClient.ramal || '')
      setValue('cep', dataClient.cep)
      setValue('origin', {
        value: dataClient.origem_orcamento,
        label: dataClient.origem_orcamento_desc,
      })
      setValue('icmsClassification', {
        value: dataClient.classificacao_icms,
        label: dataClient.classificacao_icms === 'C' ? 'Contribuinte' : 'Não contribuinte',
      })
      setValue('street', dataClient.rua)
      setValue('complement', dataClient.complemento || '')
      setValue('state', dataClient.uf)
      setValue('city', dataClient.nome_cidade)
      setValue('neighborhood', dataClient.nome_bairro)
      setValue('number', dataClient.numero_endereco)
      setValue('phoneAddress', dataClient.fax || '')
      setValue('emails', emails.map((email) => ({ email })) || [])
      setValue('editar_endereco', dataClient.editar_endereco)
      setValue(
        'contatos',
        dataClient?.contatos?.map((contato) => ({
          nome: contato.nome_contato,
          telefone: contato.telefone_contato,
          email: contato.email_contato,
          id_contato: contato.id_contato,
          celular: contato.celular_contato,
          cargo: contato.cargo || '',
          departamento: contato.departamento || '',
          apelido: contato.apelido || '',
          data_nascimento: contato.data_nascimento || null,
        }))
      )
    }
  }, [dataClient, setValue])

  const userPermission = user?.codigo_usuario !== 30 ? user?.codigo_usuario : 0

  const editarEndereco = watch('editar_endereco')

  console.log('errors', errors)

  return (
    <>
      {isOpen && (
        <Modal isOpen={isOpen} onClose={onClose} size="full">
          <ModalOverlay />
          <FormProvider {...methods}>
            <ModalContent as="form" onSubmit={handleSubmit(handleEdit)}>
              <ModalHeader mb={4} py="14px" color="#378BBF" bg="#F5F5F5" textAlign="center">
                <Flex flexDir="column" gap={1}>
                  <Text>
                    EDITAR CLIENTE - {dataClient.nome_parceiro} - {dataClient.codigo_parceiro}
                  </Text>

                  <Flex alignItems="center" justifyContent="center" gap={2}>
                    <Badge colorScheme="blue">
                      {dataClient.quantidade_pedidos}{' '}
                      <Text
                        textDecor="underline"
                        as={'a'}
                        href={`/pedidos-vendedor/${userPermission}?pedidos=true&cliente_pedido=${dataClient.codigo_parceiro}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Pedidos
                      </Text>
                    </Badge>
                    <Badge colorScheme="green">
                      {dataClient.quantidade_orcamentos}{' '}
                      <Text
                        textDecor="underline"
                        as={'a'}
                        href={`/propostas/${userPermission}?acompanhamento_proposta=s&cliente_orcamento=${dataClient.codigo_parceiro}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Orçamentos
                      </Text>
                    </Badge>
                  </Flex>
                </Flex>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <SimpleGrid
                  columns={{
                    base: 1,
                    md: 2,
                    lg: 3,
                  }}
                  spacing={4}
                  maxW="1366px"
                  mx="auto"
                >
                  <Flex
                    flexDir="column"
                    w="full"
                    gap={2}
                    borderRight="1px solid #ccc!important"
                    //espaçamento da borda
                    pr={4}
                  >
                    <Text fontSize="12px" fontWeight="semibold" textAlign="center" py={'6px'} bg="#F5F5F5">
                      CONTATO PRINCIPAL
                    </Text>

                    <Input width="100%" label="Nome" error={errors.name} {...register('name')} />
                    <Input width="100%" label="Email" error={errors.email} {...register('email')} />
                    <InputMaskForm
                      maskChar=""
                      mask="(99) 99999-9999"
                      width="100%"
                      label="Celular"
                      control={control}
                      name="cellphoneClient"
                      error={errors.cellphoneClient}
                    />
                    {/* <Input width="100%" label="Telefone" {...register('phoneClient')} /> */}
                    <InputMaskForm
                      maskChar=""
                      mask="(99) 9999-9999"
                      width="100%"
                      label="Telefone"
                      control={control}
                      name="phoneClient"
                      error={errors.phoneClient}
                    />
                  </Flex>

                  <Flex flexDir="column" w="full" gap={2} borderRight="1px solid #ccc!important" pr={4}>
                    <Text fontSize="12px" fontWeight="semibold" textAlign="center" py={'6px'} bg="#F5F5F5">
                      DADOS DA EMPRESA
                    </Text>

                    <SimpleGrid columns={2} spacing={2}>
                      <Origem />
                      <TipoDePessoa />
                      <GridItem colSpan={2}>
                        <ConsultaCPFCnpj isDisabled />
                      </GridItem>

                      <ConsultarReceita />

                      <Flex alignItems="center" gap={2} ml="auto">
                        <Text fontSize="12px" textTransform="uppercase" fontWeight="bold">
                          Cliente especial
                        </Text>
                        <Switch size="md" {...register('specialClient')} />
                      </Flex>

                      <GridItem colSpan={2}>
                        <Input width="100%" label="Nome Parceiro" {...register('partnerName')} error={errors.partnerName} />
                      </GridItem>
                      <GridItem colSpan={2}>
                        <Input width="100%" label="Razão Social" {...register('socialReason')} error={errors.socialReason} />
                      </GridItem>
                      <GridItem colSpan={1}>
                        <Input width="100%" label="Insc. Estadual / Identidade" {...register('stateRegistration')} error={errors.stateRegistration} />
                      </GridItem>
                      <GridItem colSpan={1}>
                        <ClassificacaoICMS dataClient={dataClient} />
                      </GridItem>

                      <GridItem colSpan={2}>
                        <Input width="100%" label="Contrato" {...register('contract')} error={errors.contract} disabled />
                      </GridItem>
                    </SimpleGrid>
                  </Flex>

                  <Flex flexDir="column" w="full" gap={2}>
                    <Text fontSize="12px" fontWeight="semibold" textAlign="center" py={'6px'} bg="#F5F5F5">
                      ENDEREÇO
                    </Text>

                    <SimpleGrid columns={6} spacing={2}>
                      <GridItem colSpan={6}>
                        <InputSearchCep />
                      </GridItem>
                      <GridItem colSpan={6} position="relative">
                        <Input width="100%" label="Rua" {...register('street')} error={errors.street} disabled={!editarEndereco} />

                        <Flex alignItems="start" flexDir="column" gap={2} position="absolute" top="0" right="0px">
                          <CheckboxGroup>
                            <Flex alignItems="center" gap={2}>
                              <Checkbox id="editar_endereco" {...register('editar_endereco')} isChecked={editarEndereco} disabled={editarEndereco} />

                              <Text as="label" fontSize="12px" htmlFor="editar_endereco">
                                Editar endereço
                              </Text>
                            </Flex>
                          </CheckboxGroup>
                        </Flex>
                      </GridItem>
                      <GridItem colSpan={3}>
                        <Input width="100%" label="Número" {...register('number')} error={errors.number} />
                      </GridItem>
                      <GridItem colSpan={3}>
                        <Input width="100%" label="Complemento" {...register('complement')} error={errors.complement} />
                      </GridItem>
                      <GridItem colSpan={6}>
                        <Input width="100%" label="Bairro" {...register('neighborhood')} error={errors.neighborhood} disabled={!editarEndereco} />
                      </GridItem>
                      <GridItem colSpan={5}>
                        <Input width="100%" label="Cidade" {...register('city')} error={errors.city} disabled={!editarEndereco} />
                      </GridItem>
                      <GridItem colSpan={1}>
                        <Input width="100%" label="Estado" {...register('state')} error={errors.state} disabled={!editarEndereco} />
                      </GridItem>
                      <GridItem colSpan={5}>
                        <InputMaskForm
                          id="phoneE"
                          maskChar=""
                          mask="(99) 99999-9999"
                          width="100%"
                          label="Telefone do Endereço"
                          control={control}
                          name="phoneAddress"
                          error={errors.phoneAddress}
                        />
                      </GridItem>
                      <GridItem colSpan={1}>
                        <Input width="100%" label="Ramal" {...register('branch')} error={errors.branch} />
                      </GridItem>
                    </SimpleGrid>

                    <Emails />
                  </Flex>

                  <GridItem colSpan="3">
                    <ListaContato idParceiro={dataClient.id_parceiro} dataClient={dataClient} />
                  </GridItem>
                </SimpleGrid>
              </ModalBody>

              <ModalFooter>
                <Button bgColor="#378BBF" colorScheme="blue" mr={3} onClick={onClose}>
                  Fechar
                </Button>
                <Button variant="ghost" type="submit" isLoading={isLoading}>
                  Confirmar e Salvar
                </Button>
              </ModalFooter>
            </ModalContent>
          </FormProvider>
        </Modal>
      )}
    </>
  )
}
